import {
  CentralSessionControls,
  RightsideSessionControls,
  SessionControl,
  SessionControlsLayout,
} from '../../../components';
import { ToolbarSeparator } from '../../../components/ToolbarSeparator';
import {
  ScreenShareControlWrapper as ScreenShareControl,
  ScreenShareMenuItemsWrapper as ScreenShareMenuItems,
} from '../../../session/controls/ScreenShareControl';
import { useObscuredVisitorContentProps } from '../../a11y';
import {
  VisitorAdditionalOptionsMenuWrapper as VisitorAdditionalOptionsMenu,
  VisitorAudioControlWrapper as VisitorAudioControl,
  VisitorVideoControlWrapper as VisitorVideoControl,
} from '../../controls';
import {
  IntentionsDrawerControlMenuItemWrapper as IntentionsDrawerControlMenuItem,
  IntentionsDrawerControlsWrapper as IntentionsDrawerControls,
} from '../../intentions/IntentionsDrawerControls';
import { RecordingControl } from '../../session-recording/RecordingControl';
import { LeaveSessionButtonWrapper as LeaveSessionButton } from '../LeaveSessionButton';
import {
  VisitorMeetingChatDrawerButton,
  VisitorMeetingChatDrawerMenuItemWrapper as VisitorMeetingChatDrawerMenuItem,
} from './VisitorMeetingChatDrawerControls';
import {
  VisitorMeetingMeasureDrawerControlButton,
  VisitorMeetingMeasureDrawerControlMenuItem,
} from './VisitorMeetingMeasureDrawerControl';
import {
  VisitorMeetingReflectionTopicsDrawerControlButton,
  VisitorMeetingReflectionTopicsDrawerControlMenuItem,
} from './VisitorMeetingReflectionTopicsDrawerControl';
import {
  VisitorMeetingSettingsControlButton,
  VisitorMeetingSettingsDrawerControlMenuItem,
} from './VisitorMeetingSettingsDrawerControls';

const centralControls: SessionControl[] = [
  {
    key: 'audio',
    toolbarComponent: VisitorAudioControl,
  },
  {
    key: 'video',
    toolbarComponent: VisitorVideoControl,
  },
  {
    key: 'av-separator',
    toolbarComponent: ToolbarSeparator,
  },
  {
    key: 'chat',
    toolbarComponent: VisitorMeetingChatDrawerButton,
    additionalOptionsMenuItemComponent: VisitorMeetingChatDrawerMenuItem,
  },
  {
    key: 'reflection-topics',
    toolbarComponent: VisitorMeetingReflectionTopicsDrawerControlButton,
    additionalOptionsMenuItemComponent: VisitorMeetingReflectionTopicsDrawerControlMenuItem,
  },
  {
    key: 'measures',
    toolbarComponent: VisitorMeetingMeasureDrawerControlButton,
    additionalOptionsMenuItemComponent: VisitorMeetingMeasureDrawerControlMenuItem,
  },
  {
    key: 'screenshare',
    toolbarComponent: ScreenShareControl,
    additionalOptionsMenuItemComponent: ScreenShareMenuItems,
  },
  {
    key: 'intentions',
    toolbarComponent: IntentionsDrawerControls,
    additionalOptionsMenuItemComponent: IntentionsDrawerControlMenuItem,
  },
  {
    key: 'recording',
    toolbarComponent: RecordingControl,
  },
  {
    key: 'session-tools-separator',
    toolbarComponent: ToolbarSeparator,
  },
  {
    key: 'settings',
    toolbarComponent: VisitorMeetingSettingsControlButton,
    additionalOptionsMenuItemComponent: VisitorMeetingSettingsDrawerControlMenuItem,
  },
];

export function VisitorMeetingSessionControlsWrapper() {
  const obscuredContentProps = useObscuredVisitorContentProps();

  return (
    <SessionControlsLayout {...obscuredContentProps} className='order-3'>
      <CentralSessionControls
        controls={centralControls}
        additionalOptionsMenuComponent={VisitorAdditionalOptionsMenu}
      />
      <RightsideSessionControls>
        <LeaveSessionButton />
      </RightsideSessionControls>
    </SessionControlsLayout>
  );
}
